import styled, { css } from 'styled-components';
import { BaseScaleButton } from '@bit/wavfichacerta.fichacerta.shared-styles.buttons'

export const SubmitButton = styled(BaseScaleButton)`
  background-color: ${props => {
    if (props.disabled) {
      return props.theme.color_gray;
    }

    return props.theme.color_purple;
  }};
  padding: .55rem 1.25rem !important;
  border-radius: 10px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  border: 1px solid rgba(0, 0, 0, 0.12);
  color: #fff;
  background: linear-gradient(180deg, #1a3d66 0%, #152b4e 55%, #122845 100%);
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.12) inset, 0 2px 6px rgba(21, 43, 78, 0.25);
  ${props => css`${props.customstyle}`};
`;

export const BtHeader = styled.button`
  outline: 0;
  border: 0;
  background: transparent;
  text-align: center;
  display: inline-block;
  font-size: .7rem;
  color: ${props => props.theme.color_gray};

  &:focus { outline: 0; }

  &:disabled {
    & > a {
      cursor: initial;
      & > svg {
        fill: ${props => props.theme.color_gray};
      }
      &:hover {
        transform: unset;
      }
    }
  }
`;

export const ButtonLink = styled.a`
  height: 1.2rem;
  display: block;
  width: 2rem;
  height: 2rem;
  border-radius: 100%;
  background-color: ${props => props.theme.color_beige} !important;
  border: 1px solid;
  align-items: center;
  display: flex;
  justify-content: center;
  margin: auto;
  box-shadow: 0px 0px 4px ${props => props.theme['color_gray-X11-gray']};
  border-color: transparent;
  -webkit-transform: scale(1);
  -ms-transform: scale(1);
  -moz-transform: scale(1);
  transform: scale(1);
  cursor: pointer;

  &:hover {
    transition: all 200ms ease-in;
    transform: scale(1.1);
  }
`;
